import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ToastComponent } from './utils/toast/toast.component';

@Component({
  selector: 'app-inside',
  templateUrl: './inside.component.html',
  styleUrls: ['./inside.component.css']
})
export class InsideComponent implements OnInit, AfterViewInit {

  @ViewChild('toast', { static: false }) toast  : ToastComponent | undefined;


  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  userInfo : UserInfo | undefined;

  constructor(public loginService: LoginService, public translate: TranslateService, public router: Router, public toastService: ToastService) {
    this.translate.setDefaultLang(localStorage.getItem('language_dm7') || 'it');
    this.innerWidth = window.innerWidth;
  }


  async ngOnInit() {
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");

  }

  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toast!);
  }
}
